import { TFavoriteEntityType } from '../../../types/favorites';
import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EToggleFavoritesEntityType {
  Toggle = 'toggleFavoritesEntityType/toggled',
}

export type TToggleFavoritesType = ITypedReduxAction<EToggleFavoritesEntityType.Toggle, TFavoriteEntityType>;
